import React from 'react';
import { default as bemCssModules } from 'bem-css-modules';
import * as AddToBasketFailedEvent from '@ori-events/add-to-basket-failed';
import { default as ErrorNotificationStyles } from './ErrorNotification.module.css';
const style = bemCssModules(ErrorNotificationStyles);
const ERROR_REMOVAL_TIMEOUT = 3000;
export const ErrorNotification = () => {
    const [errorMessage, setErrorMessage] = React.useState('');
    const onError = (event) => {
        setErrorMessage(event.detail.localizedMessage);
        setTimeout(() => {
            setErrorMessage('');
        }, ERROR_REMOVAL_TIMEOUT);
    };
    React.useEffect(() => {
        window.addEventListener(AddToBasketFailedEvent.Name, onError);
        return () => {
            window.removeEventListener(AddToBasketFailedEvent.Name, onError);
        };
    }, []);
    if (!errorMessage) {
        return null;
    }
    return (React.createElement("div", { className: style() },
        React.createElement("svg", { className: style('icon'), version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "44", height: "64", viewBox: "0 0 44 64" },
            React.createElement("path", { d: "M22 55.375c12.131 0 22-9.869 22-22s-9.869-22-22-22-22 9.869-22 22 9.869 22 22 22zM22 14.125c10.613 0 19.25 8.637 19.25 19.25s-8.637 19.25-19.25 19.25-19.25-8.637-19.25-19.25 8.637-19.25 19.25-19.25zM20.625 34.75v-11c0-0.76 0.615-1.375 1.375-1.375s1.375 0.615 1.375 1.375v11c0 0.76-0.615 1.375-1.375 1.375s-1.375-0.615-1.375-1.375zM20.351 42.726c0-0.913 0.736-1.649 1.649-1.649s1.649 0.736 1.649 1.649c0 0.913-0.736 1.649-1.649 1.649s-1.649-0.736-1.649-1.649z" })),
        React.createElement("span", null, errorMessage)));
};
